import { Module, Subscription } from '@/modules/moduleSubscription/types/module'
import { ShoppingCartItems } from '@/modules/moduleSubscription/types/ShoppingCart'
import WebStorageService from '@/modules/_services/webstorage.service'
import WebStorageKey from '@/enums/web-storage-key.enum'
import { handleAddToCartForGtm } from './gtmHandlers'
import { toast } from '@/modules/base/components/toast/toastConfig'
import lang from '@/lang'
import { cloneDeep } from 'lodash'
import { getMaxCartCount } from '@/modules/moduleSubscription/constants'

export const addItemToCart = (
  type: string,
  item: Module | Subscription,
  value: number,
  replace = false,
  items: ShoppingCartItems,
  enableItemsFromStorage?: boolean,
) => {
  const itemName = item.name
  const itemsCount = cloneDeep(items)
  if (!itemsCount[type]) {
    itemsCount[type] = {}
  }
  const currentCount = itemsCount[type][itemName]?.count || 0
  const newCount = !replace ? currentCount + value : value

  const count = items?.[type]?.[item.name]?.count && !replace
    ? items[type][item.name].count + value
    : value
  const maxCartCount = getMaxCartCount(item.name)
  const maxCount = item.bookable > 0 ? Math.min(item.bookable, maxCartCount) : maxCartCount

  const cartItems = {
    ...items,
    [type]: {
      ...items[type],
      [item.name]: {
        ...item,
        count: Math.min(count, maxCount),
      },
    },
  }
  if (newCount !== itemsCount[type][itemName]?.count) {
    handleAddToCartForGtm(item, newCount, type, itemsCount)
  }
  // check singleton entires
  let cleaned = false
  const validatedCardItems = Object.keys(cartItems).reduce((result, key) => {
    const subscriptionType = cartItems[key]
    result[key] = Object.keys(subscriptionType).reduce((result, key) => {
      const item = subscriptionType[key]
      if (item.singleton === true) {
        // look for other items with the same type
        const otherItems = Object.keys(cartItems).some(subType =>
          Object.keys(cartItems[subType]).some(name =>
            cartItems[subType][name].modules
            && cartItems[subType][name].modules.some(module =>
              module.includedCount > 0
              && module.module.name === item.name,
            ),
          ),
        )
        if (!otherItems) {
          result[key] = item
        } else {
          cleaned = true
        }
      } else {
        result[key] = item
      }
      return result
    }, {})
    return result
  }, {})
  if (cleaned) {
    toast.showToast({
      message: lang.moduleSubscription.list.shoppingCart.cleanUpModuleMessage,
    })
  }
  if (enableItemsFromStorage) WebStorageService.setItem(WebStorageKey.SHOPPING_CART, { items: validatedCardItems })
}
